export default {
  ConfiguracoesPayPal: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "configuracoes-paypal"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/ConfiguracoesPayPal.js
// module id = LGLF
// module chunks = 13